import { render } from "./editPatient.vue?vue&type=template&id=4f6a9d2d&scoped=true"
import script from "./editPatient.vue?vue&type=script&lang=js"
export * from "./editPatient.vue?vue&type=script&lang=js"

import "./editPatient.vue?vue&type=style&index=0&id=4f6a9d2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6a9d2d"]])

export default __exports__